import React from "react";
import API from "../config/API";
import NewCase from "../components/NewCase";
import { AiFillFilter } from "react-icons/ai"
import { FaSort, FaCaretSquareRight, FaCaretSquareLeft } from "react-icons/fa"
import { Modal } from "react-bootstrap";

class NewCases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cases: [],
      agents: [],
      FilterActive: false,
      FilterModal: false,
      Sort: null,
      index: 0,
      filter: {
        FirstSortResultFilter: "",
        AgentFilter: "",
        PatientName: "",
        CaseNumber: "",
        CaseState: "",
        SortDateFrom: "",
        SortDateTo: "",
        StudyDeliveryDateFrom: "",
        StudyDeliveryDateTo: "",
        DocumentCompletionDateFrom: "",
        DocumentCompletionDateTo: "",
        FieldVisitDateFrom: "",
        FieldVisitDateTo: ""
      }
    };

    // Updating
    this.UpdateFirstSortResultFilter = this.UpdateFirstSortResultFilter.bind(this);
    this.UpdateAgentFilter = this.UpdateAgentFilter.bind(this);
    this.UpdatePatientNameFilter = this.UpdatePatientNameFilter.bind(this);
    this.UpdateCaseNumberFilter = this.UpdateCaseNumberFilter.bind(this);
    this.UpdateCaseStateFilter = this.UpdateCaseStateFilter.bind(this);
    this.UpdateSortDateFromFilter = this.UpdateSortDateFromFilter.bind(this);
    this.UpdateStudyDeliveryDateFromFilter = this.UpdateStudyDeliveryDateFromFilter.bind(this);
    this.UpdateDocumentCompletionDateFromFilter = this.UpdateDocumentCompletionDateFromFilter.bind(this);
    this.UpdateFieldVisitDateFromFilter = this.UpdateFieldVisitDateFromFilter.bind(this);

    this.UpdateSortDateToFilter = this.UpdateSortDateToFilter.bind(this);
    this.UpdateStudyDeliveryDateToFilter = this.UpdateStudyDeliveryDateToFilter.bind(this);
    this.UpdateDocumentCompletionDateToFilter = this.UpdateDocumentCompletionDateToFilter.bind(this);
    this.UpdateFieldVisitDateToFilter = this.UpdateFieldVisitDateToFilter.bind(this);

    // Fetching
    this.GetCases = this.GetCases.bind(this);
    this.GetAgents = this.GetAgents.bind(this);

    // Other
    this.Filter = this.Filter.bind(this);
    this.FilterModal = this.FilterModal.bind(this);
    this.Reset = this.Reset.bind(this);
    this.SortCases = this.SortCases.bind(this);
    this.increaseIndex = this.increaseIndex.bind(this);
    this.decreaseIndex = this.decreaseIndex.bind(this);
  }

  async increaseIndex() {
    await this.setState({ index: this.state.index + 20 });
    this.GetCases();
  }

  async decreaseIndex() {
    await this.setState({ index: this.state.index- 20 });
    this.GetCases();
  }

  async SortCases() {
    if (this.state.Sort === "ASC") {
      const sortedCases = this.state.cases.sort((a, b) => b.c_number - a.c_number);
      this.setState({ cases: sortedCases, Sort: "DESC" });
    }

    if (this.state.Sort === "DESC") {
      const sortedCases = this.state.cases.sort((a, b) => b.c_number + a.c_number);
      this.setState({ cases: sortedCases, Sort: "ASC" });
    }
  }

  async Reset() {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        FirstSortResultFilter: "",
        AgentFilter: "",
        PatientName: "",
        CaseNumber: "",
        CaseState: "",
        SortDateFrom: "",
        SortDateTo: "",
        StudyDeliveryDateFrom: "",
        StudyDeliveryDateTo: "",
        DocumentCompletionDateFrom: "",
        DocumentCompletionDateTo: "",
        FieldVisitDateFrom: "",
        FieldVisitDateTo: ""
      },
      FilterActive: false
    }));
    this.Filter();
  }

  FilterModal() {
    this.setState({ FilterModal: !this.state.FilterModal })
  }

  async UpdateSortDateToFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        SortDateTo: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateStudyDeliveryDateToFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        StudyDeliveryDateTo: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateDocumentCompletionDateToFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        DocumentCompletionDateTo: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateFieldVisitDateToFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        FieldVisitDateTo: event.target.value,
      },
      FilterActive: true
    }));
  }


  async UpdatePatientNameFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        PatientName: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateCaseNumberFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        CaseNumber: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateCaseStateFilter(value) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        CaseState: value,
      },
      FilterActive: true
    }));
  }

  async UpdateSortDateFromFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        SortDateFrom: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateStudyDeliveryDateFromFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        StudyDeliveryDateFrom: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateDocumentCompletionDateFromFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        DocumentCompletionDateFrom: event.target.value,
      },
      FilterActive: true
    }));
  }

  async UpdateFieldVisitDateFromFilter(event) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        FieldVisitDateFrom: event.target.value,
      },
      FilterActive: true
    }));
  }

  async GetAgents() {
    const data = {
      Token: window.localStorage.getItem("token"),
    };

    await API.post("/get_agents", data)
      .then((respone) => {
        const res = respone.data;
        if (res.ErrorMessage) window.alert(res.ErrorMessage);
        if (res.data) this.setState({ agents: res.data });
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  async UpdateFirstSortResultFilter(value) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        FirstSortResultFilter: value,
      },
      FilterActive: true
    }));
  }

  async UpdateAgentFilter(value) {
    await this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        AgentFilter: value,
      },
      FilterActive: true
    }));
  }

  /* eslint-disable eqeqeq */
  async Filter() {
    this.GetCases();
  }

  async GetCases() {
    const data = {
      Token: window.localStorage.getItem("token"),
      index: this.state.index,
      filter: this.state.filter
    };

    await API.post("/get_new_cases", data)
      .then((respone) => {
        const res = respone.data;
        if (res.ErrorMessage) window.alert(res.ErrorMessage);
        if (res.data) {
          const sortedCases = res.data.sort((a, b) => b.c_number - a.c_number);
          this.setState({ cases: sortedCases, Sort: "DESC" });
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  componentDidMount() {
    this.GetCases();
    this.GetAgents();
  }

  render() {
    return (
      <div className="CenterPage">
        <div className="insideCard">
          <div className="PageContainer">
            <table className="TableContainer">
              <thead style={{ borderBottom: "1px solid rgb(201, 201, 201)" }}>
                <tr className="TableHeader">
                  <th>تفاصيل الملف</th>
                  <th>حالة الملف</th>
                  <th>تاريخ تسليم الدراسة</th>
                  <th>تاريخ استكمال الاوراق</th>
                  <th>تاريخ الزيارة الميدانية</th>
                  <th>الباحثة المكلفة</th>
                  <th>نتيجة الفرز الاولي</th>
                  <th>تاريخ قرار الفرز</th>
                  <th>اسم المريض</th>
                  <th>رقم الملف</th>
                  <th>
                    <AiFillFilter size={20} onClick={this.FilterModal} />
                    <FaSort size={20} onClick={this.SortCases} />
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.cases.map((element, i) => {
                  return (
                    <NewCase
                      key={i}
                      CaseID={element.c_id}
                      number={element.c_number}
                      PatientName={element.c_patient_name}
                      agent={element.c_agent}
                      SortDate={element.c_sort_date}
                      FirstSortResult={element.c_first_sort_result}
                      FieldVisitDate={element.c_field_visit_date}
                      DocumentCompletionDate={element.c_document_completion_date}
                      StudyDeliveryDate={element.c_study_delivery_date}
                      notes={element.c_notes}
                      state={element.c_state}
                      CommentsCount={element.comments_count}
                    />
                  );
                })}
              </tbody>
            </table>

            <Modal show={this.state.FilterModal} onHide={this.FilterModal}>
              <Modal.Header>
                <Modal.Title>تصفية النتائج</Modal.Title>
              </Modal.Header>
              <Modal.Body>

                <div className="input-container" style={{ paddingRight: "10px" }}>
                  <label for="title-input">رقم الحالة</label>
                  <input
                    type="text"
                    id="title-input"
                    name="title-input"
                    className="input"
                    onChange={this.UpdateCaseNumberFilter}
                    placeholder="التصفية حسب رقم الملف"
                    value={this.state.filter.CaseNumber}
                    style={{
                      fontSize: "13px",
                      padding: " 7px",
                      width: "300px"
                    }}
                  />
                </div>

                <div className="input-container" style={{ paddingRight: "10px" }}>
                  <label for="title-input">الاسم</label>
                  <input
                    type="text"
                    id="title-input"
                    name="title-input"
                    className="input"
                    placeholder="التصفية حسب اسم المريض "
                    value={this.state.filter.PatientName}
                    onChange={this.UpdatePatientNameFilter}
                    style={{
                      fontSize: "13px",
                      padding: " 7px",
                      width: "300px",
                      textAlign: "right"
                    }}
                  />
                </div>

                {/* <div className="input-group-row">
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>&zwnj;</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateSortDateFromFilter}
                      value={this.state.filter.SortDateFrom}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "-5px",
                      }}
                    />
                  </div>
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>تاريخ قرار الفرز</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateSortDateToFilter}
                      value={this.state.filter.SortDateTo}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "5px",
                      }}
                    />
                  </div>
                </div> */}

                {/* <div
                  className="input-group-row"
                  style={{ marginTop: "-10px" }}
                >
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label style={{ marginTop: "10px" }}>نتيجة الفرز الاولي</label>
                    <select
                      className="input"
                      onChange={(e) => this.UpdateFirstSortResultFilter(e.target.value)}
                      value={this.state.filter.FirstSortResultFilter}
                    >
                      <option value="الغاء">الغاء</option>
                      <option value="دراسة">دراسة</option>
                      <option value="عدم دراسة">عدم دراسة</option>
                    </select>
                  </div>
                </div> */}

                <div
                  className="input-group-row"
                  style={{ marginTop: "-10px" }}
                >
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label style={{ marginTop: "10px" }}>الباحثة المكلفه</label>
                    <select
                      className="input"
                      onChange={(e) => this.UpdateAgentFilter(e.target.value)}
                      value={this.state.filter.AgentFilter}>
                      <option value="الغاء">الغاء</option>
                      {this.state.agents.map((agent, i) => {
                        return (
                          <option key={i} value={agent.ag_name}>{agent.ag_name}</option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {/* 
                <div className="input-group-row">
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>&zwnj;</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateFieldVisitDateFromFilter}
                      value={this.state.filter.FieldVisitDateFrom}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "-5px",
                      }}
                    />
                  </div>
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>تاريخ الزيارة الميدانية</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateFieldVisitDateToFilter}
                      value={this.state.filter.FieldVisitDateTo}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "5px",
                      }}
                    />
                  </div>
                </div>

                <div className="input-group-row">
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>&zwnj;</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateDocumentCompletionDateFromFilter}
                      value={this.state.filter.DocumentCompletionDateFrom}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "-5px",
                      }}
                    />
                  </div>
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>تاريخ استكمال الاوراق</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateDocumentCompletionDateToFilter}
                      value={this.state.filter.DocumentCompletionDateTo}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "5px",
                      }}
                    />
                  </div>
                </div>

                <div className="input-group-row">
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>&zwnj;</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateStudyDeliveryDateFromFilter}
                      value={this.state.filter.StudyDeliveryDateFrom}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "-5px",
                      }}
                    />
                  </div>
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label>تاريخ تسلم الدراسة</label>
                    <input
                      type="date"
                      name="title-input"
                      onChange={this.UpdateStudyDeliveryDateToFilter}
                      value={this.state.filter.StudyDeliveryDateTo}
                      style={{
                        fontSize: "13px",
                        padding: " 7px",
                        width: "150px",
                        marginRight: "5px",
                      }}
                    />
                  </div>
                </div>

                <div className="input-group-row" style={{ marginTop: "-10px" }}>
                  <div className="input-container" style={{ paddingRight: "10px" }}>
                    <label style={{ marginTop: "10px" }}>حالة الملف</label>
                    <select className="input" onChange={(e) => this.UpdateCaseStateFilter(e.target.value)} >
                      // {this.state.filter.CaseState === "" ?
                      //   (<option disabled selected>لا يوجد</option>)
                      //   :
                      //   ""
                      // }
                      <option value="">الغاء</option>
                      <option value="محول">محول</option>
                      <option value="غير محول">غير محول</option>
                    </select>
                  </div>
                </div> */}

              </Modal.Body>
              <Modal.Footer>
                <button className="button1" onClick={this.FilterModal}>
                  اغلاق
                </button>
                <button className="button1" onClick={this.Filter}>
                  بحث
                </button>
                <button
                  className="button2"
                  onClick={this.Reset}
                >
                  اعادة ضبط الفلاتر
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
        <div style={{ textAlign: "center"}}>
          {this.state.index > 0 ? <FaCaretSquareLeft onClick={this.decreaseIndex}/> : null}
          {this.state.cases.length < 20 ? null : <FaCaretSquareRight onClick={this.increaseIndex}/>}
        </div>
      </div>
    );
  }
}

export default NewCases;
